import { SwitchButtonProps } from '../types/modules/ButtonsTypes';
import { useRouter } from 'next/router';

export const SwitchButton: React.FC<SwitchButtonProps> = (props: SwitchButtonProps) => {
  const { textLeft, textRight, buttonLeft, buttonRight, className } = props;
  const router = useRouter();
  const activeButtonClass = 'border-2 border-[#24C1FF] !bg-gray-900';

  return (
    <div
      className={`rounded-full flex items-center justify-center border-none ${
        router.asPath === '/pricing' ||
        router.asPath === '/pricing/individual' ||
        router.asPath === '/pricing/studio'
          ? 'w-[224px] bg-gray-900'
          : 'bg-a-gray bg-opacity-[30%]'
      }`}>
      <button onClick={props.onClick} className={`${className} ${buttonLeft && activeButtonClass}`}>
        {textLeft}
      </button>
      <button
        onClick={props.onClick}
        className={`${className} ${buttonRight && activeButtonClass}`}>
        {textRight}
      </button>
    </div>
  );
};

export const SwitchButtonMinimal: React.FC<SwitchButtonProps> = (props: SwitchButtonProps) => {
  const { textLeft, textRight, buttonLeft, buttonRight, onClick } = props;

  const divLeftClass = buttonLeft
    ? 'flex items-center justify-start bg-[#4D5457] w-[51px] h-[31px] rounded-full cursor-pointer transition-all duration-300'
    : 'flex items-center justify-end bg-a-blue w-[51px] h-[31px] rounded-full cursor-pointer transition-all duration-300';

  const leftSpanClass = buttonLeft
    ? 'text-white font-bold text-[16px] leading-[24px] transition-colors duration-300'
    : 'text-[#7F898D] font-bold text-[16px] leading-[24px] transition-colors duration-300';

  const rightSpanClass = buttonRight
    ? 'text-white font-bold text-[16px] leading-[24px] transition-colors duration-300'
    : 'text-[#7F898D] font-bold text-[16px] leading-[24px] transition-colors duration-300';

  return (
    <div
      className="flex items-center justify-center gap-5"
      onClick={onClick}
      data-cy="switch-container">
      <span className={leftSpanClass}>{textLeft}</span>
      <div className={divLeftClass} data-cy="toggle-container">
        <button className="bg-white rounded-full w-[25px] h-[25px] mx-[3px] right-0"></button>
      </div>
      <span className={rightSpanClass}>{textRight}</span>
    </div>
  );
};
